'use client';
import { App } from '@web/query/App';
import { Company } from '@web/store/Company';
function Register() {
  const defaultCountries = Company.useCompany((state) => state.defaultCountries);
  App.Context.useRegister({
    category: 'company',
    countries: defaultCountries && defaultCountries.length > 0 ? defaultCountries : undefined,
  });
  App.Context.useRegister({ category: 'people' });

  return null;
}

export { Register };
